import users from './users.saga';

export default [...users];
